import { IconButton, styled } from '@mui/material'
import { InlineForwardIcon } from '$common/icons/inline-forward'
import { useClientUserHasPermissionToForwardMessage } from '$logic/subscription/react-hook'

const Root = styled(IconButton)`
  width: 40px;
  height: 40px;
  /* @noflip */
  align-self: flex-end;

  padding: 8px;
  background-color: #00000033;
  /* @noflip */
  margin-left: 12px;

  &:hover {
    background-color: #00000033;
  }
`

export function ForwardButton({
  onClick,
  roomId,
}: {
  onClick: () => unknown
  roomId: string
}) {
  const canForward = useClientUserHasPermissionToForwardMessage(roomId)

  if (!canForward) return null
  return (
    <Root onClick={onClick}>
      <InlineForwardIcon sx={{ scale: '-1 1' }} />
    </Root>
  )
}
